import React, { useState, useEffect } from 'react';
//import ReactPixel from 'react-facebook-pixel';
import { saveCheckout } from '@/services/reservationService';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

export const useBooking = spaceDetail => {
  const [isLoading, setIsLoading] = useState(false);
  const lenguage = useSelector(state => state.lenguage?.lang);
  const userCardList = useSelector(state => state.userCardList);
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();

  const doCheckout = async (spaceDetail, totalPrice) => {
    const parsedTotalPrice = parseFloat(totalPrice);
    const amount = Math.round(parsedTotalPrice * 100);
    const currency = spaceDetail?.currency?.toLowerCase();

    const reservation = {
      host_id: 1,
      guest_id: 2,
      space_subtype_relationship: spaceDetail?.id_relationship,
      //start_date: formValues?.startDate,
      //finish_date: formValues?.startDate,
      start_date: '2024-12-01',
      finish_date: '2024-12-05',
      initial_price: parsedTotalPrice,
      final_price: parsedTotalPrice,
      id_state: 1,
      payment_method: 1,
      method_status: 'p',
      method_details: 'Credit Card',
    };

    //const paymentMethodId = 'pm_1SOK262eZvKYlo2CdS18DdFp';
    //const customerId = 'cus_TL02arynlMm847';

    const defaultCard = userCardList.find(card => card.isDefault === true);
    const paymentMethodId = defaultCard?.id;
    console.log('ver pauyment ', paymentMethodId);
    const customerId = defaultCard?.customerId;

    const { createdReservation } = await saveCheckout({
      amount,
      currency,
      reservation: reservation,
      paymentMethodId: paymentMethodId,
      customerId: customerId,
    });

    if (!createdReservation) {
      setErrorMessage('Hubo un error al procesar el pago');
    } else {
      navigate(
        '/new-reservation-confirmed?transaction_id=' +
          createdReservation?.transaction_id,
      );
    }
  };

  useEffect(() => {
    if (spaceDetail.length >= 1) {
      setIsLoading(false);
    }
  }, [spaceDetail]);

  return {
    isLoading,
    setIsLoading,
    doCheckout,
    errorMessage,
  };
};
